import * as policyEngine from '@/domain/restriction/engine';
import { isFirefox } from '@/lib/systemHelpers/browserHelpers';
import { localRights } from '@/pages/dokkaPay/pages/company/components/PaymentsWorkspace/helpers/contextMenuHelper';

import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import MergeTypeOutlinedIcon from '@mui/icons-material/MergeTypeOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import CancelScheduleSendOutlinedIcon from '@mui/icons-material/CancelScheduleSendOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const items = [
  {
    id: 'startPaymentProcess',
    title: 'Start payment process',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: CurrencyExchangeOutlinedIcon,
  },
  {
    id: 'sendToApproval',
    title: 'Send to approval',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
    icon: SendOutlinedIcon,
  },
  {
    id: 'approve',
    title: 'Approve',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(
      localRights.paramsName.payIsOwner,
      localRights.paramsName.payIsController,
      localRights.paramsName.payIsApprover,
    ),
    icon: PlaylistAddCheckOutlinedIcon,
    color: 'success',
  },
  {
    id: 'resetApprovalFlow',
    title: 'Reset approval flow',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
    icon: CancelScheduleSendOutlinedIcon,
    color: 'warning',
  },
  {
    id: 'pay',
    title: 'Pay',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    separator: true,
    icon: CreditCardOutlinedIcon,
  },
  {
    id: 'sendByEmail',
    title: 'Share via email',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
    icon: ForwardToInboxOutlinedIcon,
  },
  {
    id: 'printDocuments',
    title: 'Print documents',
    disabled: isFirefox,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    comingSoon: true,
    icon: PrintOutlinedIcon,
  },
  {
    id: 'downloadDocuments',
    title: 'Download documents',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.isAuthorized),
    separator: true,
    comingSoon: true,
    icon: CloudDownloadOutlinedIcon,
  },
  {
    id: 'mergePayments',
    title: 'Merge payments',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: MergeTypeOutlinedIcon,
  },
  {
    id: 'saveForLater',
    title: 'Save for later',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: BookmarkAddOutlinedIcon,
  },
  {
    id: 'archive',
    title: 'Archive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: ArchiveOutlinedIcon,
  },
  {
    id: 'unarchive',
    title: 'Unarchive',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: UnarchiveOutlinedIcon,
  },
  {
    // no `separator` on the preceding item: BulkActions renders the divider *after* it, which would
    // leave a dangling divider whenever Delete itself is hidden. The error colour is the separation.
    id: 'deletePayments',
    title: 'Delete payments',
    disabled: false,
    action: () => null,
    restriction: localRights.policy(localRights.paramsName.payIsOwner, localRights.paramsName.payIsController),
    icon: DeleteOutlineOutlinedIcon,
    color: 'error',
  },
];

export const filteredItem = (p: { restriction: policyEngine.UserRights }) => {
  const lr = localRights.restriction(p.restriction);

  return items.filter(policyEngine.arrayFilter(lr)).map(policyEngine.arrayMap(lr, 'disabled'));
};
